export default {
    T_AND_C: 't_and_c',
};